<template>
  <div class="list-results">
    <template v-if="contentType === 'Courses'">
      <div
        v-for="item in items"
        :key="item.objectID"
        class="list-results__item"
      >
        <ListResult
          :type="contentType"
          :course="item"
          :gradient="$getGradient()"
          :tileImg="$getCourseBackground(item.objectID, 'small')"
          :duration="
            item.duration && item.duration.length
              ? $duration.getCourseDuration(item)
              : '0:00'
          "
          :link="$buildContentLink('course', item)"
          :difficulty="item.difficulty || ''"
          :isFreeTrialUser="isFreeTrialUser"
        />
      </div>
    </template>
    <template v-if="contentType === 'Learning Paths'">
      <div
        v-for="item in items"
        :key="item.objectID"
        class="list-results__item"
      >
        <ListResult
          :type="contentType"
          :course="item"
          :gradient="$getGradient()"
          :tileImg="$getPlaylistBackground(item.objectID)"
          :link="$buildContentLink('path', item)"
          :duration="
            item.duration && item.duration.length
              ? $duration.getCourseDuration(item)
              : '0:00'
          "
          :difficulty="item.difficulty || ''"
        />
      </div>
    </template>
    <template v-if="contentType === 'Videos'">
      <VideoListResults
        :items="items"
        :parentsSeachResults="parentsSeachResults"
        @open-video="$emit('open-video', $event)"
      />
    </template>
    <template v-if="contentType === 'Bootcamps'">
      <BootcampListResults :items="items" />
    </template>
  </div>
</template>

<script>
import ListResult from '@/components/search/ListResult.vue'
import BootcampListResults from '@/components/search/BootcampListResults.vue'
import VideoListResults from '@/components/search/VideoListResults.vue'

export default {
  name: 'ListResults',
  components: {
    ListResult,
    VideoListResults,
    BootcampListResults,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    parentsSeachResults: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openVideo(video) {
      this.$emit('open-video', video)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-results {
  display: flex;
  flex-wrap: wrap;
  &__item {
    display: flex;
    align-items: center;
    min-width: 100%;
    min-height: 80px;
    padding: 0 5px;
    margin: 5px 0 0 0;
    @include mobile {
      margin: 0 0 10px 0;
      padding: 15px 0 5px 15px;
    }
    &:nth-of-type(even) {
      background-color: var(--light-gray);
    }
  }
}
</style>
